{
  "en": {
    "materialGenerationPromptModal": {
      "buttons": {
        "generate": "Generate suggestion"
      },
      "description": "The draft of the {material} is based on your {sourceKind} content and can always be edited and expanded.",
      "headers": {
        "fallbackTitle": "Create material with AI",
        "title": "Create {material} for {sourceKind} with AI"
      },
      "labels": {
        "language": "Language",
        "prompt": "Requirements"
      },
      "help": {
        "prompt": "Additionally describe the target audience, teaching context, and focus for the {material} here. Mention any guiding questions, learning objectives, or special requirements if applicable."
      },
      "placeholders": {
        "prompt": "Describe the target group, lesson context, and focus for the {material}. Add a guiding question, learning goal, or special requirements if helpful."
      }
    }
  }
}
